<button
  phx-button
  type="button"
  phxTrigger="click"
  phxDropdownClassName="phx-menu-button-dropdown"
  [disabled]="disabled"
  [phxLoading]="phxLoading"
  [phxSize]="phxSize"
  [phxButtonRole]="phxButtonRole"
  [phxButtonType]="phxButtonType"
  [phxBackground]="phxBackground"
  [phxDropdownFor]="phxDropdownTemplate"
  [phxSuffixIcon]="phxSuffixIcon"
  [phxHasShadow]="phxHasShadow"
  [phxPrefixIcon]="phxPrefixIcon"
  [phxDisableInteractions]="phxDisableInteractions"
  [phxFullWidth]="phxFullWidth"
  [phxPosition]="phxDropdownPosition"
>
  <ng-content></ng-content>
</button>
